import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { UserService } from "../../../../swaggerServices";
import { ClientNotificationService } from "../../client-notification.service";

interface IBaseProvisionArgs {
  email: string;
  provisioner: {
    adAccessToken?: string;
  }
}
interface IUserAddArgs extends IBaseProvisionArgs {
  firstName: string;
  lastName: string;
}

interface IUserRemoveArgs extends IBaseProvisionArgs {}

type UserProvisionEvent = 'add' | 'remove';

@Injectable()
export class UserProvisioningService {
  private updateSignal = new Subject<UserProvisionEvent>();
  /**
   * An observable that can be subscribed to in cases where a components needs to respond to a
   * user being added or removed (e.g. re-fetch a list of users)
   */
  public readonly updateObservable = this.updateSignal.asObservable();

  constructor(
    private userService: UserService,
    private clientNotificationService: ClientNotificationService
  ) {}

  public addUser(data: IUserAddArgs) {
    this.userService.addUser(data).subscribe(
      (response) => {
        this.clientNotificationService.appendMessage(
          "Added User successfully",
          `User Email: ${response?.email}`,
          true
        );
        this.updateSignal.next('add');
      },
      (error) => {
        console.error(error);
        this.clientNotificationService.appendMessage(
          "Unable to add user, please try again later",
          error.error || error.message || `An error occurred: ${error.status}`,
          false
        );
      }
    )
  }

  public removeUser(userId: number, data: IUserRemoveArgs) {
    const deleteResponseObservable = this.userService.deleteUserById(userId, data);

    deleteResponseObservable.subscribe(
      response => {
        this.clientNotificationService.appendMessage(
          "Removed User successfully",
          `User Email: ${response}`,
          true
        );
        this.updateSignal.next('remove');
      },
      error => {
        console.error(error);
        this.clientNotificationService.appendMessage(
          "Unable to remove user, please try again later",
          error.message || `An error occurred: ${error.status}`,
          false
        );
      }
    )
  }
}
